export enum RouteLibraryEntities {
  USER = 'user',
  CUSTOM_ROLE = 'custom-role',
  END_USER = 'end-user',
  END_USER_ANONYMOUS = 'end-user-anonymous',
  COURIER = 'courier',
  EMPLOYEE = 'employee',
  COURIER_EMPLOYEE = 'courier-employee',
  COURIER_EMPLOYEE_GROUP = 'courier-employee-group',
  COURIER_EXTENDED_REGISTRATION_FORM = 'courier-user-employee-extended-registration-form',
  LEGAL_ENTITY = 'legal-entity',
  BRANCH_OFFICE = 'branch-office',
  BAG = 'bag',
  WORK_SHIFT = 'work-shift',
  END_USER_GROUP = 'end-user-group',
  UNIT = 'unit',
  UNIT_TYPE = 'unit-type',
  CAR = 'car',
  BIKE = 'bike',
  ELECTRIC_SCOOTER = 'electric-scooter',
  ELECTRIC_BIKE = 'electric-bike',
  BABY_CARRIAGE = 'baby_carriage',
  TRAILER = 'trailer',
  ELECTRIC_QUAD_BIKE = 'electric_quad_bike',
  ELECTRIC_MOPED = 'electric-moped',
  BOAT = 'boat',
  CHARGING = 'charging',
  VELOMOBILE = 'velomobile',
  TRICYCLE = 'tricycle',
  TRACKER = 'tracker',
  IOT = 'iot',
  TRIKE = 'trike',
  ELECTRIC_SNOW_SCOOTER = 'electric-snow-scooter',
  MECHANICAL_BICYCLE_WITHOUT_IOT = 'mechanical-bicycle-without-iot',
  ELECTRIC_BICYCLE_WITHOUT_IOT = 'electric-bicycle-without-iot',
  ELECTRIC_BICYCLE_WITH_IOT = 'electric-bicycle-with-iot',
  BATTERY = 'battery',
  BUSINESS_LOGIC = 'business-logic',
  PROJECT_END_USER_LEVEL = 'project-end-user-level',
  PROJECT_END_USER_LEVEL_CONFIG = 'project-end-user-level-config',
  UNIT_GROUP = 'unit-group',
  UNIT_MODEL = 'unit-model',
  UNIT_MODEL_GROUP = 'unit-model-group',
  UNIT_HW_MODEL = 'unit-hw-model',
  UNIT_COMMAND_TEXT = 'unit-command-text',
  REPEATER = 'repeater',
  COMMAND_DESCRIPTION = 'command-description',
  END_USER_ORDER = 'end-user-order',
  PREPAID_SHARING_ORDER = 'prepaid-sharing-order',
  END_USER_PRICE_PLAN = 'end-user-price-plan',
  END_USER_PRICE_PLAN_SCHEDULE = 'end-user-price-plan-schedule',
  SUBSCRIPTION = 'subscription',
  SERVICE_REQUEST_NEW = 'service-request_new',
  SERVICE_REQUEST_IN_PROGRESS = 'service-request_in-progress',
  SERVICE_REQUEST_CLOSED = 'service-request_closed',
  SUBSCRIPTION_PRICE_PLAN = 'subscription-price-plan',
  PROJECT = 'project',
  PROJECT_COUNTRY = 'project-country',
  PAYMENT_SERVICE = 'payment-service',
  ACQUIRER = 'acquirer',
  GEO_OBJECTS_REGION = 'geo-objects-region',
  GEO_OBJECTS_GEOFENCE = 'geo-objects-geofence',
  GEO_OBJECTS_GEOPOINT = 'geo-objects-geopoint',
  GEO_OBJECTS_GEOPOINT_TYPE = 'geo-objects-geopoint-type',
  GEO_OBJECTS_WEEKLY_SCHEDULE = 'geo-objects-weekly-schedule',
  INSURANCE_PROVIDER = 'insurance-provider',
  SMS_GATEWAY = 'sms-gateway',
  SUPPORT_CONTACT = 'support-contact',
  LEGAL_DOCUMENTS = 'legal-documents',
  DOCUMENT = 'document',
  ACCEPTANCE_CERTIFICATE = 'acceptance-certificate',
  NOTIFICATION = 'notification',
  END_USER_NOTIFICATION = 'end-user-notification',
  PROMOTION_AND_NEWS = 'promotions-and-news',
  UNIT_LOG = 'unit-log',
  END_USER_LOG = 'end-user-log',
  TOURIST_ROUTE = 'tourist-route',
  TOURIST_ROUTE_POINT = 'tourist-route-point',
  PROMO_CODE = 'promo-code',
  BALANCE_PACKAGE = 'balance-package',
  BALANCE_PACKAGE_PURCHASE = 'balance-package-purchase',
  TOURIST_ROUTE_PURCHASE = 'tourist-route-purchase-list',
  COMMODITY = 'commodity',
  COMMODITY_PURCHASE = 'commodity-purchase',
  EXECUTOR_PRICE_PLAN = 'executor-price-plan',
  PREPAID_SHARING_PRICE_PLAN = 'prepaid-sharing-price-plan',
  EXECUTOR_PRICE_PLAN_GROUP = 'executor-price-plan-group',
  EXECUTOR_BILLING_LONG_TERM = 'executor-billing-long-term',
  FINANCIAL_OPERATION = 'financial-operation',
  EXECUTOR_FINANCIAL_OPERATION = 'executor-financial-operation',
  COMPONENT_TYPE = 'component-type',
  COMPONENT_MODEL = 'component-model',
  COMPONENT = 'component',
  COMPONENT_WITHOUT_SN = 'component-without-sn',
  WAREHOUSE = 'warehouse',
  CUSTOMIZATION = 'customization',
}

export type RouteLibraryEntity = typeof RouteLibraryEntities[keyof typeof RouteLibraryEntities];
